var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VBtn",
    _vm._g(
      _vm._b(
        {
          staticClass: "mobile-button",
          class: [_vm.btnClass, _vm.absolutePosition],
          attrs: {
            tag: _vm.btnTag,
            href: _vm.href,
            icon: _vm.isIcon,
            large: "",
            flat: "",
            type: "button"
          }
        },
        "VBtn",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("span", { staticClass: "btn-content" }, [
        _c("span", { staticClass: "main-content" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _c("span", { staticClass: "sub-text" }, [_vm._t("sub")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileButton.vue?vue&type=template&id=fd56a218&scoped=true&
// module id = null
// module chunks = 